
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/migration/pickers-migration",
      function () {
        return require("private-next-pages/material-ui/migration/pickers-migration.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/migration/pickers-migration"])
      });
    }
  